import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { imageAssets } from '@app/core/constants/themes';
import { ThemeService } from '@app/core/services/theme.service';
import { FaqQuestionResponse } from '@app/sales/models/simcard.model';
import { IconNames } from '@app/shared/enums/icon-names';
import { Theme } from '@app/support/models/theme.model';
import { SupportService } from '@app/support/services/support.service';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IceIconButtonComponent } from '@app/shared/components/atoms/ice-icon-button/ice-icon-button.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-esim-info-modal',
  templateUrl: './esim-info-modal.component.html',
  styleUrl: './esim-info-modal.component.scss',
  imports: [MatIcon, IceIconButtonComponent, SpinnerComponent, AsyncPipe],
})
export class EsimInfoModalComponent implements OnInit {
  themeService = inject(ThemeService);
  private supportService = inject(SupportService);

  IconNames = IconNames;
  imageAssets = imageAssets;

  @ViewChild('esimDialog') esimDialog: ElementRef<HTMLDialogElement>;

  eSimCompatiblePhones$: Observable<FaqQuestionResponse>;
  selectedTheme$: Observable<Theme>;

  ngOnInit(): void {
    this.selectedTheme$ = this.themeService.selectedTheme;
  }

  openModal() {
    this.esimDialog.nativeElement.showModal();
    this.eSimCompatiblePhones$ ||= this.supportService.getFaqQuestion('eSimDeviceList');
    this.esimDialog.nativeElement.addEventListener('click', this.handleDialogClick);
  }

  closeModal() {
    this.esimDialog.nativeElement.close();
  }

  private handleDialogClick(event: MouseEvent): void {
    if (!event?.currentTarget) return;

    // Because the dialog element covers the entire viewport, it will always be currentTarget
    const dialogElement = event.currentTarget as HTMLDialogElement;
    const dialogRect = dialogElement.getBoundingClientRect();
    const isClickInsideDialog =
      event.y > dialogRect.top && event.y < dialogRect.bottom && event.x > dialogRect.left && event.x < dialogRect.right;

    if (!isClickInsideDialog) dialogElement.close();
  }
}
